import AHref from "../ahref/ahref";
import IconPreview from "../icons/icon-preview/icon-preview";
import FontBody3 from "../fonts/font-body3/font-body3";
import './preview-link.scss';
import { FONT_COLOR } from "../fonts/font-props";

interface IPreviewLinkProps {
    href?: string,
    text?: React.ReactNode,
    disabled?: boolean,
}

const PreviewLink: React.FC<IPreviewLinkProps> = ({ href, text = 'Preview', disabled = false }) => {
	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation();
	}
    
    return (
        <span className={`preview-link ${disabled ? 'disabled': ''}`} onClick={handleClick}>
            <AHref href={ (!href || disabled) ? '' : href } target="_blank">
                <FontBody3 color={FONT_COLOR.ACCENT1}><IconPreview /> {text}</FontBody3>
            </AHref>
        </span>
    );
}

export default PreviewLink;